export default __webpack_public_path__ + "static/media/fmWebApp3.485e7a66.jpg";